export type ChapterUpgradeId =
  | "pickup_radius"
  | "time_bonus"
  | "combo_window"
  | "slow_security"
  | "starting_shield";

export interface ChapterUpgrade {
  id: ChapterUpgradeId;
  category: "Score" | "Survival" | "Utility";
  name: string;
  description: string;
}

export interface ChapterUpgradeState {
  pickupRadius: number;
  timeBonusScale: number;
  comboWindowBonus: number;
  hazardSpeedScale: number;
  startingShield: number;
}

export const EMPTY_CHAPTER_UPGRADES: ChapterUpgradeState = {
  pickupRadius: 0,
  timeBonusScale: 1,
  comboWindowBonus: 0,
  hazardSpeedScale: 1,
  startingShield: 0,
};

export const CHAPTER_UPGRADES: Record<ChapterUpgradeId, ChapterUpgrade> = {
  pickup_radius: { id: "pickup_radius", category: "Utility", name: "Gem Magnet", description: "+15% pickup reach" },
  time_bonus: { id: "time_bonus", category: "Survival", name: "Clockwork", description: "+20% diamond time" },
  combo_window: { id: "combo_window", category: "Score", name: "Fast Hands", description: "+0.25s combo window" },
  slow_security: { id: "slow_security", category: "Survival", name: "Signal Jammer", description: "Hazards move 12% slower" },
  starting_shield: { id: "starting_shield", category: "Utility", name: "Safe Entry", description: "Start with one shield" },
};

const categoryChoices: Record<ChapterUpgrade["category"], ChapterUpgradeId[]> = {
  Score: ["combo_window"],
  Survival: ["time_bonus", "slow_security"],
  Utility: ["pickup_radius", "starting_shield"],
};

export const upgradeChoicesFor = (level: number): ChapterUpgrade[] =>
  (["Score", "Survival", "Utility"] as const).map((category, index) => {
    const choices = categoryChoices[category];
    return CHAPTER_UPGRADES[choices[(level + index) % choices.length]];
  });

export const applyChapterUpgrade = (
  state: ChapterUpgradeState,
  id: ChapterUpgradeId,
): ChapterUpgradeState => {
  switch (id) {
    case "pickup_radius": return { ...state, pickupRadius: state.pickupRadius + 0.15 };
    case "time_bonus": return { ...state, timeBonusScale: state.timeBonusScale + 0.2 };
    case "combo_window": return { ...state, comboWindowBonus: state.comboWindowBonus + 0.25 };
    case "slow_security": return {
      ...state,
      hazardSpeedScale: Math.max(0.65, state.hazardSpeedScale - 0.12),
    };
    case "starting_shield": return { ...state, startingShield: 1 };
  }
};
